import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mergeStyles } from 'wix-rich-content-common';
import DefaultColorPicker from './DefaultColorPicker.js';
import AddColorIcon from '../../Icons/AddColorIcon.js';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import './CustomColorPickerDialog.js';
import 'wix-rich-content-ui-components';

var css_248z = ".a7544,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.mRt8l{font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);position:relative}[dir] .mRt8l{margin:0}[dir] ._9xRUm.Hu4Vx{transform:scale(.7)}[dir] ._9xRUm.Hu4Vx:after{border-color:var(--ricos-settings-text-color,#000);transform:scale(1.45)}.IjVr1{color:var(--ricos-fallback-color,#000);font-size:16px}[dir=ltr] .IjVr1{padding:10px 0 7px 20px}[dir=rtl] .IjVr1{padding:10px 20px 7px 0}.bi-rE{height:1px;width:auto}[dir] .bi-rE{background:var(--ricos-settings-dividers-color,rgba(51,51,51,.1));border:none;margin:11px 0 8px}[dir] .D3OJo .bi-rE{margin:0}._9xRUm{-webkit-flex:none;flex:none;height:20px;justify-self:center;outline:0;position:relative;width:20px}[dir] ._9xRUm{cursor:pointer;margin-top:12px;padding:0}.D3OJo ._9xRUm{align-self:center;height:34px;justify-self:center;width:34px}[dir] .D3OJo ._9xRUm{margin:0}[dir] ._9xRUm{border:1px solid #ccc;border-radius:var(--ricos-settings-small-buttons-border-radius,50%)}._9xRUm:after{bottom:1px;box-sizing:border-box;content:\" \";display:block;height:20px;outline:0;position:relative;width:20px}[dir] ._9xRUm:after{background:transparent;border:1px solid transparent;border-radius:var(--ricos-settings-color-palette-selected-button-border-radius,50%)}[dir=ltr] ._9xRUm:after{right:1px}[dir=rtl] ._9xRUm:after{left:1px}.D3OJo ._9xRUm:after{bottom:1px;height:34px;width:34px}[dir=ltr] ._9xRUm.bS8Y-{background:linear-gradient(to top left,#fff calc(50% - .8px),red 50%,#fff calc(50% + .8px),#fff)}[dir=rtl] ._9xRUm.bS8Y-{background:linear-gradient(to top right,#fff calc(50% - .8px),red 50%,#fff calc(50% + .8px),#fff)}._9xRUm:active,._9xRUm:focus,._9xRUm:hover{outline:0}[dir] ._9xRUm:not(.Hu4Vx):focus:after{border-color:#ccc}.Mv69r{width:auto}.D3OJo .Mv69r{height:100%}[dir] .D3OJo .Mv69r{margin:0 auto}[dir] .ADNLT{margin-top:-2px}.ADNLT svg{fill:var(--ricos-settings-action-color,var(--ricos-action-color,#0261ff))}.D3OJo .ADNLT{align-self:center;justify-self:center}.D3OJo .ADNLT svg{height:34px;vertical-align:bottom;width:34px}[dir] .D3OJo .ADNLT svg{transform:none}.rCFN7{fill:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff));height:18px;position:relative;width:18px}[dir] .rCFN7{cursor:pointer}.HLoex{display:grid;gap:8px;grid-template-columns:repeat(6,auto);width:180px}[dir] .HLoex{margin:0 12px 9px}.D3OJo .HLoex{grid-row-gap:24px;width:auto}[dir] .D3OJo .HLoex{margin:0;padding:24px 20px 22px}.L4Wr8{height:23px;overflow:hidden;position:absolute;width:100%;z-index:-1}[dir] .L4Wr8{background-color:transparent;border:none}[dir=ltr] .L4Wr8{left:0}[dir=rtl] .L4Wr8{right:0}.Xqr1G{line-height:normal}._-5HCH{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff));font-size:14px;font-stretch:normal;font-style:normal;font-weight:300;letter-spacing:normal;line-height:1.5;position:relative}[dir] ._-5HCH{cursor:pointer}.D3OJo ._-5HCH{font-size:16px}.KCbO4{display:flex;justify-content:space-between}[dir] .KCbO4{margin:10px 10px 0}.D3OJo .KCbO4{justify-content:center}[dir] .D3OJo .KCbO4{margin:8px 0}";
var styles = {"fontElementMap":"a7544","colorPicker":"mRt8l","colorPicker_button":"_9xRUm","colorPicker_button_selected":"Hu4Vx","colorPicker_header":"IjVr1","colorPicker_separator":"bi-rE","mobile":"D3OJo","colorPicker_button_transparent":"bS8Y-","colorPicker_palette":"Mv69r","colorPicker_add_color_button":"ADNLT","colorPicker_add_color_label":"rCFN7","colorPicker_buttons_container":"HLoex","colorPicker_color_button_hidden":"L4Wr8","colorPicker_reset_color_button":"Xqr1G","colorPicker_reset_color_label":"_-5HCH","colorPicker_bottom_container":"KCbO4"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ColorPicker extends PureComponent {
  constructor(props) {
    super(props);
    __publicField(this, "setColor", (color, e) => {
      this.setState({ color });
      this.props.onChange({ color, event: e });
    });
    __publicField(this, "onCustomColorPicked", (color) => {
      this.props.onCustomColorPicked(color);
    });
    __publicField(this, "resetColor", (e) => {
      this.props.onResetColor({ event: e });
    });
    __publicField(this, "renderAddColorButton", () => {
      const { styles: styles2 } = this;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          key: `add_color_button_${this.id}`,
          className: styles2.colorPicker_add_color_button,
          "data-hook": "addColor"
        },
        /* @__PURE__ */ React.createElement(
          "label",
          {
            onClick: this.toggleCustomColorPicker,
            tabIndex: -1,
            className: styles2.colorPicker_add_color_label,
            htmlFor: `add_color_button_${this.id}`
          },
          /* @__PURE__ */ React.createElement(
            "button",
            {
              id: `add_color_button_${this.id}`,
              className: styles2.colorPicker_color_button_hidden,
              onClick: () => this.toggleCustomColorPicker
            }
          ),
          /* @__PURE__ */ React.createElement(AddColorIcon, null)
        )
      );
    });
    __publicField(this, "renderResetColorButton", () => {
      const { styles: styles2 } = this;
      const { t } = this.props;
      return /* @__PURE__ */ React.createElement("div", { key: `reset_color_button_${this.id}`, className: styles2.colorPicker_reset_color_button }, /* @__PURE__ */ React.createElement(
        "label",
        {
          onClick: this.resetColor,
          "data-hook": "resetColor",
          tabIndex: -1,
          className: styles2.colorPicker_reset_color_label,
          htmlFor: `reset_color_button_${this.id}`
        },
        t("ColorPicker_SetToDefault_ButtonLabel"),
        /* @__PURE__ */ React.createElement(
          "button",
          {
            id: `reset_color_button_${this.id}`,
            className: styles2.colorPicker_color_button_hidden,
            onClick: this.resetColor
          }
        )
      ));
    });
    __publicField(this, "renderPalette", () => this.renderColorButtons(this.props.palette, this.props.schemeAttributes));
    __publicField(this, "renderUserColors", () => this.renderColorButtons(this.props.userColors));
    this.styles = mergeStyles({ styles, theme: props.theme });
    this.id = `cpk_${Math.floor(Math.random() * 9999)}`;
    this.state = {
      color: this.props.color,
      isCustomColorPickerOpened: false
    };
    this.toggleCustomColorPicker = this.toggleCustomColorPicker.bind(this);
    this.onCustomColorUpdate = this.onCustomColorUpdate.bind(this);
    this.onCustomColorCancel = this.onCustomColorCancel.bind(this);
    this.onCustomColorPicked = this.onCustomColorPicked.bind(this);
  }
  componentDidMount() {
    import('./CustomColorPicker.js');
  }
  componentWillReceiveProps(props) {
    if (this.props.color !== props.color) {
      this.setState({ color: props.color });
    }
  }
  onColorButtonClicked(color, e) {
    if (e.target.dataset.schemeColor) {
      this.setColor(e.target.dataset.schemeColor, e);
    } else {
      this.setColor(color, e);
    }
  }
  onCustomColorUpdate(color) {
    if (color !== this.state.color) {
      this.props.onColorAdded({ color });
    }
    this.setColor(color);
    this.toggleCustomColorPicker();
  }
  onCustomColorCancel() {
    this.toggleCustomColorPicker();
  }
  toggleCustomColorPicker() {
    this.setState((prevState) => ({
      isCustomColorPickerOpened: !prevState.isCustomColorPickerOpened
    }));
  }
  renderColorButtons(colors, attributes) {
    const { styles: styles2 } = this;
    const { schemeColor } = this.props;
    return colors.map((color, index) => /* @__PURE__ */ React.createElement(
      "button",
      {
        "data-hook": "modal-option",
        "data-scheme-color": attributes ? attributes[index] : "",
        title: color,
        key: `${color}_${index}`,
        className: classNames({
          [styles2.colorPicker_button]: true,
          [styles2.colorPicker_button_selected]: this.state.color === color && (!schemeColor || !attributes || attributes[index] === schemeColor),
          [styles2.colorPicker_button_transparent]: color === "transparent"
        }),
        style: color !== "transparent" ? { background: color } : {},
        onClick: (e) => this.onColorButtonClicked(color, e)
      }
    ));
  }
  renderSeparator() {
    const { styles: styles2 } = this;
    return /* @__PURE__ */ React.createElement("hr", { className: styles2.colorPicker_separator });
  }
  render() {
    const {
      styles: styles2,
      renderPalette,
      renderUserColors,
      renderAddColorButton,
      renderResetColorButton
    } = this;
    const { t, isMobile, theme, children } = this.props;
    return /* @__PURE__ */ React.createElement("div", { className: classNames(styles2.colorPicker, { [styles2.mobile]: isMobile }), tabIndex: 0 }, this.state.isCustomColorPickerOpened ? this.props.onCustomPickerToggle({
      color: this.state.color,
      onCustomColorPicked: this.onCustomColorPicked,
      onCustomColorCancel: this.onCustomColorCancel,
      onCustomColorUpdate: this.onCustomColorUpdate,
      t,
      isMobile,
      theme
    }) : children({
      renderPalette,
      renderUserColors,
      renderAddColorButton,
      renderResetColorButton,
      mergedStyles: styles2
    }));
  }
}
ColorPicker.propTypes = {
  theme: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  defaultColor: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onResetColor: PropTypes.func,
  palette: PropTypes.arrayOf(PropTypes.string).isRequired,
  schemeAttributes: PropTypes.arrayOf(PropTypes.string),
  schemeColor: PropTypes.string,
  userColors: PropTypes.arrayOf(PropTypes.string),
  t: PropTypes.func,
  onColorAdded: PropTypes.func.isRequired,
  onCustomPickerToggle: PropTypes.func,
  onCustomColorPicked: PropTypes.func,
  isMobile: PropTypes.bool,
  children: PropTypes.func.isRequired
};
ColorPicker.defaultProps = {
  onCustomPickerToggle: (props) => /* @__PURE__ */ React.createElement(DefaultColorPicker, __spreadValues({}, props)),
  onCustomColorPicked: () => {
  }
};

export { ColorPicker };
//# sourceMappingURL=ColorPicker.js.map
